import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './LoginPage.css';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_9363419a-0d44-45af-86ed-64a5aaaae19b/artifacts/drx2byx3_Logo%20DTC.png';

export default function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await login(email, password);
      navigate('/admin');
    } catch (err) {
      setError(err.message || 'Error al iniciar sesión');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page" data-testid="login-page">
      <div className="login-card">
        <div className="login-header">
          <img src={LOGO_URL} alt="Dogos El Tío Chepe" className="login-logo" />
          <h1>Panel de Administración</h1>
          <p>Ingresa tus credenciales para continuar</p>
        </div>

        <form onSubmit={handleSubmit} className="login-form" data-testid="login-form">
          {error && (
            <div className="login-error" data-testid="login-error">
              {error}
            </div>
          )}

          <div className="login-field">
            <label htmlFor="email">Correo electrónico</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="admin@dogostiochepe.com"
              required
              autoComplete="email"
              data-testid="login-email-input"
            />
          </div>

          <div className="login-field">
            <label htmlFor="password">Contraseña</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              required
              autoComplete="current-password"
              data-testid="login-password-input"
            />
          </div>

          <button
            type="submit"
            className="login-btn"
            disabled={loading}
            data-testid="login-submit-btn"
          >
            {loading ? 'Ingresando...' : 'Ingresar'}
          </button>
        </form>

        <a href="/" className="login-back" data-testid="login-back-link">
          ← Volver al sitio
        </a>
      </div>
    </div>
  );
}
